import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Slide, ToastContainer, toast } from 'react-toastify';

import { typeChecker } from '../../../utils/methods';
import { _post } from '../../../utils/network';
import { LocalStorage } from '../../../services';

import BackgroundImage from '../../../assets/images/backgrounds/login-bg.jpg';

import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const Login = () => {
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	const codeInputRef = useRef(null);
	const [loginState, setLoginState] = useState('send-mobile');
	const [sendMobileButtonIsLoading, setSendMobileButtonIsLoading] = useState(false);
	const [sendCodeButtonIsLoading, setSendCodeButtonIsLoading] = useState(false);

	const sendMobile = async (event) => {
		event.preventDefault();
		if(sendMobileButtonIsLoading)
			return 0;
		let mobile = event.target.loginMobile.value.trim();
		if(!typeChecker(mobile, 'mobile'))
			return toast.warn(t('enter_mobile_number_correctly'));
		let body = {
			username: mobile
		};
		setSendMobileButtonIsLoading(true);
		let response = await _post('/admins/admin/login', body);
		setSendMobileButtonIsLoading(false);
		switch(response.code){
			case 200:
				let token = response.data.token;
				LocalStorage.clear();
				LocalStorage.set('token', token);
				LocalStorage.remove('verify-login');
				setLoginState('send-code');
				toast.success(response[t('api_message')]);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	}
	const sendCode = async (event) => {
		event.preventDefault();
		if(sendCodeButtonIsLoading)
			return 0;
		let code = event.target.loginCode.value.trim();
		if(!typeChecker(code, 'otp_code'))
			return toast.warn(t('enter_sms_code_correctly'));
		let body = {
			sms_code: code
		};
		setSendCodeButtonIsLoading(true);
		let response = await _post('/admins/admin/validate', body);
		setSendCodeButtonIsLoading(false);
		switch(response.code){
			case 200:
				let token = response.data.token;
				let permissions = response.data.profile.permissions;
				LocalStorage.set('token', token);
				LocalStorage.set('permissions', permissions);
				LocalStorage.set('verify-login', 'true');
				navigate('/dashboard');
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	}

	useEffect(() => {
		if(loginState === 'send-code')
			document.getElementById('login-code').focus();
	}, [loginState]);
	
	return (
		<main className="main" id="top">
			<div className="container-fluid">
				<div className="row min-vh-100 bg-100">
					<div className="col-6 d-none d-lg-block position-relative">
						<div className="bg-holder" style={{backgroundImage:`url(${BackgroundImage})`, backgroundPosition: '50% 20%'}}></div>
					</div>
					<div className="col-sm-10 col-md-6 px-sm-0 align-self-center mx-auto py-5">
						<div className="row justify-content-center g-0">
							<div className="col-lg-9 col-xl-8 col-xxl-6">
								<div className="card">
									<div className="card-header bg-circle-shape bg-shape text-center p-2">
										<a className="font-sans-serif fw-bolder fs-4 z-1 position-relative link-light" href="../../../index.html" data-bs-theme="light">{t('project_name')}</a>
									</div>
									<div className="card-body p-4">
										<div className="row flex-between-center">
											<div className="col-auto">
												<h3>{t('login')}</h3>
											</div>
										</div>
										{loginState === 'send-mobile' ?
											<form onSubmit={sendMobile}>
												<div className="mb-3">
													<label className="form-label" htmlFor="login-mobile">{t('mobile')}</label>
													<input className="form-control ltr" id="login-mobile" type="text" maxLength={11} name="loginMobile" />
												</div>
												<div className="mb-3">
													<LoadingButton className="btn btn-primary d-block w-100 mt-3" type="submit" name="submit" isLoading={sendMobileButtonIsLoading}>{t('get_sms_code')}</LoadingButton>
												</div>
											</form>
										: ''}
										{loginState === 'send-code' ?
											<form onSubmit={sendCode}>
												<div className="mb-3">
													<label className="form-label" htmlFor="login-code">{t('code')}</label>
													<input className="form-control ltr" id="login-code" type="text" maxLength={5} name="loginCode" ref={codeInputRef} />
												</div>
												<div className="row flex-between-center">
													<div className="col-auto">
														<div className="form-check mb-0">
															<input className="form-check-input" type="checkbox" id="login-remember" name="loginRemember" />
															<label className="form-check-label mb-0" htmlFor="login-remember">{t('remember_me')}</label>
														</div>
													</div>
													<div className="col-auto fs--1">
														<Link onClick={() => setLoginState('send-mobile')}>{t('edit_mobile_number')}</Link>
													</div>
												</div>
												<div className="mb-3">
													<LoadingButton className="btn btn-primary d-block w-100 mt-3" type="submit" name="submit" isLoading={sendMobileButtonIsLoading}>{t('log_in')}</LoadingButton>
												</div>
											</form>
										: ''}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ToastContainer
				position="top-center"
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop
				closeOnClick
				rtl={i18n.language !== 'en'}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="colored"
				transition={Slide}
			/>
		</main>
	);
};

export default Login;
